import React from 'react';
import { calculateCommissionBreakdown, formatGBP, SERVICE_FEE_PERCENT } from '../lib/commissionPricing';

export const CommissionFeeBreakdown = ({ amount, testId }) => {
  const pricing = calculateCommissionBreakdown(amount);
  return (
    <div className="space-y-3" data-testid={`${testId}-breakdown`} aria-live="polite">
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="text-white/60">Withdrawal amount</span>
        <span className="text-white font-medium" data-testid={`${testId}-withdrawal`}>{formatGBP(pricing.withdrawalAmount)}</span>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="text-white/60" data-testid={`${testId}-fee-label`}>Service fee ({SERVICE_FEE_PERCENT}%)</span>
        <span className="text-white/80" data-testid={`${testId}-fee`}>-{formatGBP(pricing.serviceFee)}</span>
      </div>
      <div className="h-px bg-white/10" />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-white font-semibold">You'll receive</span>
        <span className="text-xl sm:text-2xl font-bold text-[#59d862] break-all" data-testid={`${testId}-net`}>{formatGBP(pricing.netAmount)}</span>
      </div>
      <p className="text-xs text-white/50 leading-relaxed" data-testid={`${testId}-fee-explanation`}>
        The {SERVICE_FEE_PERCENT}% service fee applies only to the commission you withdraw.
      </p>
    </div>
  );
};